import Button from 'src/components/buttons/button';
import i18n from 'src/utils/translate';
import { showModal, closeModal } from 'src/modules/shared/modal/actions';
import { resendVerificationLink } from 'src/modules/shared/context/actions';
import { truncate } from 'underscore.string';
import { useDispatch, useSelector } from 'react-redux';
import ModalType from 'src/constants/modalTypes';
import { State } from 'src/types';
import styled from 'styled-components';

export default function VerificationBar() {
  const dispatch = useDispatch();

  const { currentUser, showVerificationBar } = useSelector(({context}: State) => context);

  if (!currentUser || !showVerificationBar) return null;

  const unverifiedEmail = truncate(currentUser?.unverifiedEmail || '', 40);

  const onResendEmailClick = () => {
    dispatch(resendVerificationLink());
    dispatch(closeModal());
  };

  const onInformationClick = () => {
    dispatch(showModal({
      modalType: ModalType.EMAIL_CONFIRMATION,
      modalProps: {
        unverifiedEmail,
        onResendEmailClick,
      },
    }));
  };

  return (
    <div className="verification-bar">
      <div className="verification-bar__inner">
        <div className="verification-bar__copy">
          {i18n.t('Confirm your email by clicking the link we sent to %1$s').replace('%1$s', unverifiedEmail)}
          <span className="icon-information" onClick={onInformationClick} />
        </div>
        <div className="verification-bar__actions">
          <StyledButton
            text="Resend email"
            onClick={onResendEmailClick}
          />
          <a href={`/settings#email-update_settings`}>
            <StyledButton
              border="none"
              text="Change email"
            />
          </a>
        </div>
      </div>
    </div>
  );
}

const StyledButton = styled(Button)`
  background-color: ${({theme}) => theme.colorMagenta};
  border: 1px solid ${({theme}) => theme.colorWhite};
`;
